var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _vm.summary
    ? _c("div", { staticClass: "bn-mechanism-summary" }, [
        _c("section", { staticClass: "bn-mechanism-summary__block" }, [
          _c("h3", { staticClass: "bn-mechanism-summary__heading" }, [
            _vm._v("Overall summary"),
          ]),
          _c("p", { staticClass: "bn-mechanism-summary__text" }, [
            _vm._v(_vm._s(_vm.summary.overall_summary || "—")),
          ]),
          _c("div", { staticClass: "bn-mechanism-summary__meta" }, [
            _c("span", { staticClass: "bn-mechanism-summary__badge" }, [
              _vm._v(
                " Confidence: " +
                  _vm._s(_vm.summary.overall_confidence || "—") +
                  " "
              ),
            ]),
            _c(
              "span",
              {
                staticClass:
                  "bn-mechanism-summary__badge bn-mechanism-summary__badge--muted",
              },
              [
                _vm._v(
                  " Grounding: " +
                    _vm._s(_vm.summary.grounding_level || "—") +
                    " "
                ),
              ]
            ),
          ]),
          _vm.summary.confidence_rationale
            ? _c("p", { staticClass: "bn-mechanism-summary__muted" }, [
                _vm._v(" " + _vm._s(_vm.summary.confidence_rationale) + " "),
              ])
            : _vm._e(),
        ]),
        _vm.geneBridges.length
          ? _c(
              "section",
              { staticClass: "bn-mechanism-summary__block" },
              [
                _c("h3", { staticClass: "bn-mechanism-summary__heading" }, [
                  _vm._v("Gene bridges"),
                ]),
                _vm._l(_vm.geneBridges, function (bridge, idx) {
                  return _c(
                    "div",
                    {
                      key: "bridge-" + idx,
                      staticClass: "bn-mechanism-summary__card",
                    },
                    [
                      _c(
                        "div",
                        { staticClass: "bn-mechanism-summary__card-head" },
                        [
                          _c("strong", [
                            _vm._v(_vm._s(bridge.gene_symbol || "—")),
                          ]),
                          _c(
                            "span",
                            { staticClass: "bn-mechanism-summary__muted" },
                            [
                              _vm._v(
                                " · " +
                                  _vm._s(
                                    bridge.biomarker_count != null
                                      ? bridge.biomarker_count
                                      : "?"
                                  ) +
                                  " biomarker" +
                                  _vm._s(
                                    bridge.biomarker_count === 1 ? "" : "s"
                                  ) +
                                  " "
                              ),
                            ]
                          ),
                        ]
                      ),
                      _c("p", { staticClass: "bn-mechanism-summary__text" }, [
                        _vm._v(_vm._s(bridge.connection_summary || "—")),
                      ]),
                      _c("div", { staticClass: "bn-mechanism-summary__meta" }, [
                        _c(
                          "span",
                          { staticClass: "bn-mechanism-summary__badge" },
                          [_vm._v(_vm._s(bridge.confidence || "—"))]
                        ),
                        _c(
                          "span",
                          {
                            staticClass:
                              "bn-mechanism-summary__badge bn-mechanism-summary__badge--muted",
                          },
                          [_vm._v(_vm._s(bridge.grounding || "—"))]
                        ),
                      ]),
                    ]
                  )
                }),
              ],
              2
            )
          : _vm._e(),
        _vm.highlighted.length
          ? _c(
              "section",
              { staticClass: "bn-mechanism-summary__block" },
              [
                _c("h3", { staticClass: "bn-mechanism-summary__heading" }, [
                  _vm._v("Highlighted biomarkers"),
                ]),
                _vm._l(_vm.highlighted, function (item, idx) {
                  return _c(
                    "div",
                    {
                      key: "bio-" + idx,
                      staticClass: "bn-mechanism-summary__card",
                    },
                    [
                      _c(
                        "div",
                        { staticClass: "bn-mechanism-summary__card-head" },
                        [
                          _c("strong", [
                            _vm._v(_vm._s(item.biomarker_id || "—")),
                          ]),
                        ]
                      ),
                      _c("p", { staticClass: "bn-mechanism-summary__muted" }, [
                        _vm._v(
                          " Genes: " +
                            _vm._s(_vm.formatGenes(item.associated_genes)) +
                            " "
                        ),
                      ]),
                      _c("p", { staticClass: "bn-mechanism-summary__muted" }, [
                        _vm._v(
                          " Roles: " +
                            _vm._s(item.roles || "—") +
                            " · Diseases: " +
                            _vm._s(item.diseases || "—") +
                            " "
                        ),
                      ]),
                      _c("p", { staticClass: "bn-mechanism-summary__text" }, [
                        _vm._v(_vm._s(item.brief_connection || "—")),
                      ]),
                    ]
                  )
                }),
              ],
              2
            )
          : _vm._e(),
        _vm.causalSteps.length
          ? _c(
              "section",
              { staticClass: "bn-mechanism-summary__block" },
              [
                _c("h3", { staticClass: "bn-mechanism-summary__heading" }, [
                  _vm._v("Proposed causal path"),
                ]),
                _vm.showCausalNetwork
                  ? _c("biomarker-mechanism-link-causal-network", {
                      attrs: {
                        summary: _vm.summary,
                        "mechanism-label": _vm.mechanismLabel,
                      },
                    })
                  : _vm._e(),
                _c(
                  "ul",
                  { staticClass: "bn-mechanism-summary__steps" },
                  _vm._l(_vm.causalSteps, function (step, idx) {
                    return _c("li", { key: "step-" + idx }, [
                      _c("strong", [_vm._v(_vm._s(step.label) + ":")]),
                      _vm._v(" " + _vm._s(step.text) + " "),
                    ])
                  }),
                  0
                ),
              ],
              1
            )
          : _vm._e(),
        _vm.summary.disease_role_context
          ? _c("section", { staticClass: "bn-mechanism-summary__block" }, [
              _c("h3", { staticClass: "bn-mechanism-summary__heading" }, [
                _vm._v("Disease & role context"),
              ]),
              _c("p", { staticClass: "bn-mechanism-summary__text" }, [
                _vm._v(_vm._s(_vm.summary.disease_role_context)),
              ]),
            ])
          : _vm._e(),
        _vm.caveats.length
          ? _c("section", { staticClass: "bn-mechanism-summary__block" }, [
              _c("h3", { staticClass: "bn-mechanism-summary__heading" }, [
                _vm._v("Caveats & gaps"),
              ]),
              _c(
                "ul",
                { staticClass: "bn-mechanism-summary__list" },
                _vm._l(_vm.caveats, function (item, idx) {
                  return _c("li", { key: "caveat-" + idx }, [
                    _vm._v(_vm._s(item)),
                  ])
                }),
                0
              ),
            ])
          : _vm._e(),
      ])
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }